import React from 'react';
import { bonuses } from '../data/modules';
export function Bonuses() {
  return <section className="border-b border-line bg-carbon py-8 sm:py-10" data-id="element-19" data-mp="pjpx9t6ljn8q">
      <div className="mx-auto max-w-[1080px] px-4 sm:px-6" data-id="element-20" data-mp="pm29rqtl55ee">
        <h2 className="text-center text-[24px] font-bold leading-none text-white sm:text-[38px]" data-id="element-21" data-mp="au1x4va5iuml">
          🎁 5 professional bonuses{' '}
          <span className="text-mod-yellow" data-id="element-22" data-mp="fs3ftf3o0rxj">included</span>
        </h2>

        <div className="mt-5 grid gap-3 lg:grid-cols-2" data-id="element-23" data-mp="1stww7o2rjpv">
          {bonuses.map((bonus, i) => <article key={bonus.label} className={`flex flex-col border border-mod-yellow/40 bg-panel2 p-4 ${i === bonuses.length - 1 ? 'lg:col-span-2' : ''}`} data-id="element-24" data-mp="5xjsrwiqgyas" data-mpi={i}>
              <p className="font-display text-[12px] uppercase tracking-[0.16em] text-mod-yellow" data-id="element-25" data-mp="3t2j4zpcp1huz">
                {bonus.label}
              </p>
              <h3 className="mt-1 text-[16px] font-bold leading-[1.1] text-white sm:text-[20px]" data-id="element-26" data-mp="1r8a6fo5wv7ga">
                {bonus.title}
              </h3>
              <p className="mt-1 text-[12.5px] font-semibold uppercase tracking-wide text-metal" data-id="element-27" data-mp="3ic3gm16vwmbn">
                {bonus.subtitle}
              </p>
              <p className="mt-2 text-[13.5px] font-medium leading-snug text-metal sm:text-[15px]" data-id="element-28" data-mp="3r5oulib85zk0">
                {bonus.body}
              </p>
              <p className="mt-auto pt-3 font-display text-[13px] uppercase tracking-wide text-white" data-id="element-29" data-mp="3n7is4mhf664w">
                {bonus.tagline}
              </p>
            </article>)}
        </div>
      </div>
    </section>;
}